import React from 'react';
import { TextInput, Flex, Checkbox, Text, Button } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Validator } from '@leverege/validator';
import S from '../Login.css';
import useForm from "../hooks/useForm.js";
import FieldErrorsComponent from "./FieldErrorsComponent.js";
const {
  t,
  tf
} = I18N.ns('login.TwoFactorVerify');
export default function TwoFactorSubmitForm(props) {
  const {
    codeVariant,
    codeClassName,
    twoFactorSettings,
    rememberMeVariant,
    rememberMeClassName,
    twoFactorMethod,
    resendCodeVariant,
    onReset2FAMethod,
    submitClassName,
    onSubmit: pOnSubmit,
    loading,
    LoadingComponent
  } = props;
  const {
    values,
    errors,
    submitDisabled,
    onChange,
    onSubmit
  } = useForm({
    fields: {
      code: {
        validator: Validator.required,
        errorMessage: tf('codeError')
      },
      rememberMe: {
        initialValue: false
      }
    },
    onSubmit: pOnSubmit
  });
  return /*#__PURE__*/React.createElement("form", {
    className: S.form,
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "colM",
    align: "stretch"
  }, /*#__PURE__*/React.createElement(TextInput, {
    variant: codeVariant,
    className: codeClassName,
    alwaysFireOnReturn: true,
    value: values.code,
    hint: t('codeHint'),
    eventData: "code",
    onChange: onChange,
    autoComplete: "one-time-code"
  }), /*#__PURE__*/React.createElement(FieldErrorsComponent, {
    errors: errors.code
  }), twoFactorSettings?.rememberMeEnabled && /*#__PURE__*/React.createElement(Checkbox, {
    variant: rememberMeVariant,
    className: rememberMeClassName,
    label: t('rememberMe'),
    value: values.rememberMe,
    eventData: "rememberMe",
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Flex, {
    variant: "rowS",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, null, twoFactorMethod.isClientSide ? t('noCodeTextClientSide') : t('noCodeText')), /*#__PURE__*/React.createElement(Button, {
    variant: resendCodeVariant,
    eventData: twoFactorMethod,
    onClick: onReset2FAMethod
  }, t('resendText'))), /*#__PURE__*/React.createElement(Button, {
    className: submitClassName,
    type: "submit",
    onClick: onSubmit
  }, loading ? /*#__PURE__*/React.createElement(LoadingComponent, null) : t('submit'))));
}